import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ReservationComponent} from './components/reservation/reservation.component';
import {AppComponent} from './app.component';
import {WidgetComponent} from './components/widget/widget.component';
import {CancelComponent} from './components/cancel/cancel.component';


const routes: Routes = [
  {path: 'googlemapsbooking', component: ReservationComponent},
  {path: 'cancel/:token', component: CancelComponent},
  {path: '', component: WidgetComponent},
  {path: 'reservation', component: ReservationComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
